import axios from 'axios';
import { message } from 'antd';
import { API_BASE_URL } from '../config/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const u = JSON.parse(raw);
      if (u?.token) {
        config.headers.Authorization = `Bearer ${u.token}`;
      }
    }
  } catch {
    // ignore
  }
  return config;
});

const isLoginRequest = (config) => {
  const u = (config?.url || '').toLowerCase();
  return u.includes('/usuarios/login');
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isLoginRequest(error.config)) {
      return Promise.reject(error);
    }

    const status = error?.response?.status;
    const backendMsg = String(error?.response?.data?.message || '');

    const tokenRelated403 =
      status === 403 && /token/i.test(backendMsg) && !/permisos/i.test(backendMsg);

    if (status === 401 || tokenRelated403) {
      try {
        localStorage.removeItem('user');
        localStorage.removeItem('refreshToken');
      } catch {
        /* ignore */
      }
      if (error.response?.data) {
        error.response.data.message = '';
      }
      message.warning('Tu sesión expiró. Ingresá de nuevo.');
      window.setTimeout(() => {
        window.location.replace('/login');
      }, 400);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
